<template>
  <b-modal id="lead-show-modal"
           :title="`${$t('lead')} #${lead ? lead.id : '-'}`"
           @show="onShow"
           @hide="onHide"
           modal-class="modal-xxl"
           hide-footer
           size="xl"
           centered>
    <LeadShowContent v-if="show"
                     @needRefresh="needsRefresh = true"/>
  </b-modal>
</template>

<script setup>
import { useStore} from "vuex"
import {computed, ref} from "vue"
import LeadShowContent from "@/components/parts/crm/LeadShowContent.vue"


const store = useStore()
const emit = defineEmits(['reloadLead'])

const lead = computed(() => store.state.crm.lead)

const show = ref(false)
const needsRefresh = ref(false)

const onShow = () => {
  show.value = true
  needsRefresh.value = false
}

const onHide = () => {
  show.value = false
  if(needsRefresh.value && lead.value?.id) {
    emit('reloadLead', lead.value.id)
  }
}

defineExpose({ show })
</script>
